export default "__VITE_ASSET__a487295f__"